export class TypeFormation {
    id: number;
    name: string;
}


